"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "stateFromHTML", {
  enumerable: true,
  get: function get() {
    return _stateFromHTML["default"];
  }
});

var _stateFromHTML = _interopRequireDefault(require("./stateFromHTML"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-import-html/lib/main.js
// module id = 1195
// module chunks = 1